import { lazy, Suspense } from 'react';
import SpinnerLoader from '@/components/SpinnerLoader';
import SetPriceModal from './SetPriceModal';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<SpinnerLoader />}>
    <Component {...props} />
  </Suspense>
);

const RidesHomeScreen = Loadable(lazy(() => import('./RidesHomeScreen')));
const SelectLocation = Loadable(lazy(() => import('./SelectLocation')));
const RideBooking = Loadable(lazy(() => import('./RideBooking')));

const ridesRoutes = [
  {
    path: '/rides',
    element: <RidesHomeScreen />,
  },
  {
    path: '/rides/select-location',
    element: <SelectLocation />,
  },
  {
    path: '/rides/booking',
    element: <RideBooking />,
  },
  {
    path:'/rides/set-price',
    element: <SetPriceModal/>,
  }
];

export default ridesRoutes;
